import { render, staticRenderFns } from "./BasicProperties.vue?vue&type=template&id=d174d16c"
import script from "./BasicProperties.vue?vue&type=script&lang=js"
export * from "./BasicProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports